import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { SITE_ORIGIN } from "@/lib/seo";

// Tek bir meta açıklama: sunucu katmanının eklediği etiket varsa içeriği güncellenir
const setDescription = (text) => {
  const all = document.querySelectorAll('meta[name="description"]');
  all.forEach((m, i) => { if (i > 0) m.remove(); });
  let m = all[0];
  if (!m) {
    m = document.createElement("meta");
    m.setAttribute("name", "description");
    document.head.appendChild(m);
  }
  m.setAttribute("content", text);
};

// Sayfa başına başlık, açıklama, canonical, robots ve yapılandırılmış veri
export default function Seo({ title, description, path, noindex = false, jsonLd = [], status }) {
  const url = path ? SITE_ORIGIN + path : null;
  useEffect(() => { if (description) setDescription(description); }, [description]);
  // Sayfada tek <title> kalır: index.html'deki sabit başlık ve kopyalar kaldırılır
  useEffect(() => {
    if (!title) return undefined;
    const fix = () => {
      const all = [...document.querySelectorAll("title")];
      const keep = all.find((t) => t.textContent === title) || all[0];
      all.forEach((t) => { if (t !== keep) t.remove(); });
      if (!keep) document.title = title;
      else if (keep.textContent !== title) keep.textContent = title;
    };
    const ids = [setTimeout(fix, 0), setTimeout(fix, 300)];
    return () => ids.forEach(clearTimeout);
  }, [title]);
  return (
    <Helmet prioritizeSeoTags>
      {title && <title>{title}</title>}
      {status && <meta name="prerender-status-code" content={String(status)} />}
      {url && <link rel="canonical" href={url} />}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="Molar Kimya" />
      {jsonLd.filter(Boolean).map((ld, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(ld)}</script>
      ))}
    </Helmet>
  );
}
